var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6b6b95;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,.947A1,1,0,0,1,5.053,2c-.753.04-1.349.089-1.815.138a1.106,1.106,0,0,0-1.069,1A33.906,33.906,0,0,0,2,6.907a33.908,33.908,0,0,0,.17,3.767,1.1,1.1,0,0,0,1.067,1A56.558,56.558,0,0,0,9,11.907a56.556,56.556,0,0,0,5.763-.23,1.1,1.1,0,0,0,1.067-1A33.915,33.915,0,0,0,16,6.907a33.913,33.913,0,0,0-.17-3.767,1.106,1.106,0,0,0-1.069-1C14.3,2.088,13.7,2.039,12.947,2a1,1,0,1,1,.106-2c.783.042,1.414.093,1.918.147a3.1,3.1,0,0,1,2.846,2.765A35.842,35.842,0,0,1,18,6.907a35.841,35.841,0,0,1-.183,3.994,3.1,3.1,0,0,1-2.844,2.765A58.49,58.49,0,0,1,9,13.907a58.489,58.489,0,0,1-5.973-.241A3.1,3.1,0,0,1,.183,10.9,35.834,35.834,0,0,1,0,6.907,35.835,35.835,0,0,1,.183,2.913,3.1,3.1,0,0,1,3.029.148C3.533.095,4.164.043,4.947,0A1,1,0,0,1,6,.947Z",
    transform: "translate(3 9.093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.207-1.707a1,1,0,0,1,0,1.414,1,1,0,0,1-1.414,0l-3.5-3.5a1,1,0,0,1,0-1.414l3.5-3.5a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414L3.414-5.5H13a1,1,0,0,1,1,1,1,1,0,0,1-1,1H3.414Z",
    transform: "translate(7.5 1) rotate(90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bf069752b6887e5a2d491d409a3e7d14.svg";
export { ForwardRef as ReactComponent };